import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GooglePlacesAutocompleteComponent } from './google-places-component';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule
  ],
  declarations: [
    GooglePlacesAutocompleteComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GooglePlacesAutocompleteComponent,
  ]
})
export class SharedModule
{
}
